import { Component, HostListener, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ObligationCategoryModel } from 'src/Models/ObligationGetLinkModel';
import { CategoryObligationService } from 'src/Services/category-obligation.service';
import { CheckAuth } from 'src/Services/utility.service';
import * as FileSaver from 'file-saver';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-category-type-cfo',
  templateUrl: './category-type-cfo.component.html',
  styleUrls: ['./category-type-cfo.component.css']
})
export class CategoryTypeCfoComponent implements OnInit {

  stateCode: any;
  tokenKey: string;
  listofCategory: ObligationCategoryModel[];
  listofCategoryExport: ObligationCategoryModel[];

  PageNumber: number = 1;
  PageSize: number;
  WhereCondition: string;
  OrderBy: string;
  CategoryName: string;


  upDowCategoryNameCSS: string = '';
  upDowMouseoverTextCSS: string = '';
  upDowActiveCSS: string = '';
  upDowSortOrderCSS: string = '';
  isAscending: boolean = false;
  isRecord: boolean = false;
  isloading: boolean = false;
  SelectedTool: string;
  totalRecordCount: number = 0;
  categoryTypeId: number = 0;
  openMenuIndex: number = -1;

  constructor(private readonly router: Router,
    private readonly checkAuth: CheckAuth,
    private readonly titleService: Title,
    private readonly toastr: ToastrService,
    private readonly categoryObligationService: CategoryObligationService,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.listofCategory = [];
    this.PageNumber = 1;
    this.PageSize = 10;
    this.WhereCondition = 'null';
    this.OrderBy = 'CategoryName';
    this.CategoryName = 'null';
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.titleService.setTitle('Categories');

  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    if (this.SelectedTool == 'view 47') {
      this.SelectedTool = 'view47';
    }
    this.GetCategory();
  }

  pageChanged($event: any) {
    this.PageNumber = parseInt($event.page);
    this.GetCategory();
  }

  GetCategory() {
    this.isloading = true;
    if (this.CategoryName == "null") this.CategoryName = " ";
    this.categoryObligationService.GetAllCategory(this.tokenKey, this.PageNumber, this.PageSize, this.CategoryName, this.OrderBy, false).subscribe(
      data => {
        this.isloading = false;
        this.listofCategory = data['obligationCategory'];
        if (this.listofCategory != null) {
          if (this.listofCategory.length == 0)
            this.isRecord = true;
          else {
            this.isRecord = false;
            this.totalRecordCount = this.listofCategory[0].totalRecordCount;
          }
        }
        else
          this.isRecord = true;
      },
      error => { this.stateCode = error }
    );

  }

  keywordFilters($event) {
    this.PageNumber = 1;
    if ($event.target.value != "" && $event.target.value != null)
      this.CategoryName = $event.target.value;
    else
      this.CategoryName = 'null';

    this.GetCategory();
  }

  sort(sortBy: string) {
    this.upDowCategoryNameCSS = '';
    this.upDowSortOrderCSS = '';
    this.upDowActiveCSS = '';
    this.upDowMouseoverTextCSS = '';

    if (!this.isAscending) {
      this.isAscending = true;
      this.OrderBy = sortBy + ' DESC';

      if (sortBy === "categoryName") {
        this.upDowCategoryNameCSS = 'fa fa-arrow-down';

      }
      else if (sortBy === "SortOrder") {
        this.upDowSortOrderCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "IsActive") {
        this.upDowActiveCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "mouseoverText") {
        this.upDowMouseoverTextCSS = 'fa fa-arrow-down';
      }
    }
    else {
      this.isAscending = false;
      this.OrderBy = sortBy;

      if (sortBy === "categoryName") {
        this.upDowCategoryNameCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "SortOrder") {
        this.upDowSortOrderCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "IsActive") {
        this.upDowActiveCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "mouseoverText") {
        this.upDowMouseoverTextCSS = 'fa fa-arrow-up';
      }
    }
    this.PageNumber = 1;
    this.GetCategory();
  }

  addCategory() {
    let navigation = '/admin/' + this.SelectedTool + '/category/manage';
    this.router.navigate([navigation]);
  }

  updateCategory(categoryTypeId) {
    let navigation = '/admin/' + this.SelectedTool + '/category/manage/' + categoryTypeId;
    this.router.navigate([navigation]);
  }

  setDeleteData(id) {
    this.categoryTypeId = id;
  }


  deleteCategory(categoryTypeId) {
    this.isloading = true;
    this.categoryObligationService.DeleteCategory(this.tokenKey, categoryTypeId).subscribe(
      data => {
        this.isloading = false;
        if (data['status'] == 'Success') {
          if (data['message'] != "")
            this.showMessage(data['message'], 'Warning', 'warning')
          else
            this.showMessage("Category Deleted successfully", 'Success', 'success')
        }
        this.GetCategory();
      },
      error => { this.stateCode = error }
    );
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
    else if (msgType == 'warning') {
      setTimeout(() => this.toastr.warning(msg, msgTitle));
    }
  }

  toggleMenu(index: number) {
    this.openMenuIndex = this.openMenuIndex === index ? -1 : index; // Toggle the menu
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.kebab-menu')) {
      this.openMenuIndex = null;
    }
  }

  ExportView47Category() {
    this.isloading = true;
    this.listofCategoryExport = [];
    if (this.CategoryName == "null") this.CategoryName = " ";
    this.categoryObligationService.GetAllCategory(this.tokenKey, this.PageNumber, this.PageSize, this.CategoryName, this.OrderBy, true).subscribe(
      data => {
        this.listofCategoryExport = data['obligationCategory'];
        if (this.listofCategoryExport != null) {
          if (this.listofCategoryExport.length > 0) {
            setTimeout(() => {
              this.DownloadView47Category();
              this.isloading = false;
            }, 2000);
          }
          else {
            this.isloading = false;
            this.toastr.error("No record found", "Error");
          }
        }
        else {
          this.isloading = false;
          this.toastr.error("No record found", "Error");
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );
  }

  DownloadView47Category() {
    let tableData = document.getElementById("ExportTable").innerHTML;

    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    let html = "<table><tr class='mainhead'> <td colspan='3'>";
    html += tableData;
    html += "</td></tr></table>";
    let name = 'ExportView47Category';
    var ctx = { worksheet: name || 'Worksheet', table: html }
    FileSaver.saveAs((uri + base64(format(template, ctx))), "ExportView47Category.xls");
  }

}
